import React, { useState, useEffect } from "react";
import { countries } from "countries-list";
import MetaData from "../../components/layout/MetaData";
import { useNavigate } from "react-router-dom";

// Redux
import { useDispatch, useSelector } from "react-redux";

import { saveShippingInfo } from "../../redux/features/cartSlice";

import CheckoutSteps from "../../components/CheckoutSteps";



const Shipping = () => {
const dispatch = useDispatch();
const navigate = useNavigate();
const { shippingInfo } = useSelector((state) => state.cart);
const countriesList = Object.values(countries);

const [address, setAddress] = useState("");
const [city, setCity] = useState("");
const [zipCode, setZipCode] = useState("");
const [phoneNo, setPhoneNo] = useState("");
const [country, setCountry] = useState("");
const [website, setWebsite] = useState("");

useEffect(() => {
  if (shippingInfo) {
    setAddress(shippingInfo?.address);
    setCity(shippingInfo?.city);
    setZipCode(shippingInfo?.zipCode);
    setPhoneNo(shippingInfo?.phoneNo);
    setCountry(shippingInfo?.country);
    setWebsite(shippingInfo?.website);
  }
}, [shippingInfo]);

const submitHandler = (e) => {
  e.preventDefault();

  dispatch(
    saveShippingInfo({
      address,
      city,
      phoneNo,
      zipCode,
      country,
      website,
    })
  );

  navigate("/payment_method");
};

  return (
    <>
      <MetaData title="Shipping Info" />
      <CheckoutSteps shipping />
      <div className="container mx-auto flex flex-wrap py-5">
        <div className="lg:w-4/4 w-full px-4 h-full">
          <form
            onSubmit={submitHandler}
            className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"
          >
            <h5 className="font-bold text-xl mb-4">Shipping address</h5>
            <hr />
            <div className="md:grid md:grid-cols-3 md:gap-4 mt-6">
              <div className="mb-4">
                <label
                  htmlFor="address_field"
                  className="block text-sm font-medium text-gray-700"
                >
                  Address
                </label>
                <input
                  type="text"
                  id="address_field"
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none sm:text-sm"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  required
                />
              </div>
              <div className="mb-4">
                <label
                  htmlFor="city_field"
                  className="block text-sm font-medium text-gray-700"
                >
                  City
                </label>
                <input
                  type="text"
                  id="city_field"
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none sm:text-sm"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                  required
                />
              </div>
              <div className="mb-4">
                <label
                  htmlFor="phone_field"
                  className="block text-sm font-medium text-gray-700"
                >
                  Phone No
                </label>
                <input
                  type="tel"
                  id="phone_field"
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none sm:text-sm"
                  value={phoneNo}
                  onChange={(e) => setPhoneNo(e.target.value)}
                  required
                />
              </div>
              <div className="mb-4">
                <label
                  htmlFor="website_field"
                  className="block text-sm font-medium text-gray-700"
                >
                  Website
                </label>
                <input
                  type="text"
                  id="website_field"
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none sm:text-sm"
                  value={website}
                  onChange={(e) => setWebsite(e.target.value)}
                />
              </div>
              <div className="mb-4">
                <label
                  htmlFor="zip_code_field"
                  className="block text-sm font-medium text-gray-700"
                >
                  Zip Code
                </label>
                <input
                  type="number"
                  id="zip_code_field"
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none sm:text-sm"
                  value={zipCode}
                  onChange={(e) => setZipCode(e.target.value)}
                  required
                />
              </div>
              <div className="mb-4">
                <label
                  htmlFor="country_field"
                  required
                  className="block text-sm font-medium text-gray-700"
                >
                  Country
                </label>
                <select
                  id="country_field"
                  className="mt-1 block w-full pl-3 pr-10 py-2 border border-gray-300 rounded-md focus:outline-none sm:text-sm"
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                  required
                >
                  <option
                    required
                    name="country"
                    value=""
                    className="block text-sm font-medium text-gray-700"
                  >
                    Select Country
                  </option>
                  {/* Assuming countriesList is available in your context or props */}
                  {countriesList.map((country) => (
                    <option
                      required
                      key={country.name}
                      value={country.name}
                      className="block text-sm font-medium text-gray-700"
                    >
                      {country.name}
                    </option>
                  ))}
                </select>
              </div>
              <button
                type="submit"
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              >
                Continue
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}


export default Shipping;
